import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import useConfiguration from '../../hooks/useConfiguration';
import useSessionStorage from '../../hooks/useSessionStorage';
import { getNotificationsData, getNotificationCounts } from './action';
import { getNotificationData } from '../Notification/action';

// eslint-disable-next-line import/no-anonymous-default-export
const NotificationHeader = (props) => {
  const { params } = useSelector(state => state.notificationHeader);
  const uploadCount = useSelector(state => state.notificationHeader?.uploadCount);
  const notificationParams = useSelector(state => state.notifications.params);
  const navigate = useNavigate();
  let refreshTimer = null;
  const config = useConfiguration();
  // const [errorMessage, setErrorMessage,setTotalCount] = useState(undefined);
  const storage = useSessionStorage();
  const login = storage.getItem('login');
  const location = useLocation();
  const dispatch = useDispatch();
  const MyNotifications = (event) => {
    event.preventDefault();
    const newparams = {
      ...notificationParams,
      employerUniqueId: login.employerUniqueId,
      employerUserId: login.employerUserId,
      page: 1,
      pageSize: 100,
      // "jobShiftId": ""
    };
    if (location.pathname === "/notifications") {
      dispatch(getNotificationData({ url: `${config.baseUrl}/Messages/GetEmployerMessageToGridwithAppMessageType`, params: newparams }));
      props?.hideHeaderNotification("/notifications")
    } else {
      navigate('/notifications');
    }
  };
  useEffect(() => {
    props.getNotificationCount(uploadCount);
  }, [uploadCount]);
  // console.log(100);
  // console.log(data);
  const refreshGpsData = () => {
    dispatch(getNotificationCounts(config.baseUrl))
    if (!refreshTimer) {
      refreshTimer = setInterval(() => {
        refreshGpsData();
      }, 60000); // 600000 120000
    }

  };
  const stopRefresh = () => {
    // console.log(`🚀 ~ file: index.js ~ line: 71 :`, { refreshTimer });
    if (refreshTimer) {
      clearInterval(refreshTimer);
      refreshTimer = null;
    }
  };

useEffect(() => {
  if(config.baseUrl){
    if(!login){
      navigate("/");
    } else {
      refreshGpsData();
    }
  }
  return () => stopRefresh();
},[config])
  return (
    <div>
      {/* {
               // errorMessage &&
                <>
                    <div
                        className="toast wrap-input100 align-items-center text-white bg-danger border-0 show"
                        role="alert" aria-live="assertive" aria-atomic="true"
                        data-bs-autohide="false">
                        <div className="d-flex col-6">
                            <div className="toast-body">
                                {errorMessage || 'GPS error! Please try again.'}
                            </div>
                        </div>
                    </div>
                    <div>&nbsp;</div>
                </>
            } */}
      {
        <>
          <div className="drop-heading border-bottom">
            <div className="d-flex">
              <h6 className="mt-1 mb-0 fs-16 fw-semibold text-dark">
                You have {uploadCount} new Uploads
              </h6>
              <i style={{right:"1.25rem", top:"0.5rem", cursor:"pointer"}} onClick={() => props?.updateNotificationFlag(prev => ({...prev,uploadFlag:false}))} className="position-absolute  fa fa-remove "></i>
              {/* <div className="ms-auto">
                       <a href="#"
                          className="text-muted p-0 fs-12">make all  unread</a>
                   </div> */}
            </div>
          </div>
          {props?.loader && <div style={{ display: "flex", alignItems: "center", justifyContent: "center", height: '200px' }}>Loading...</div>}
          {props?.data && !props?.loader && (
            <div style={{ overflowY: "auto", height: "19rem" }} className="message-menu">
              {props?.data?.map((item) => {
                return (
                  <span className="dropdown-item d-flex">
                    <span
                      className="text-primary"
                      style={{ display: "inline-flex", alignItems: "center", justifyContent: "center", background: "#D3D3D3", height: "2.25rem", width: "2.25rem", borderRadius: "100%", marginRight: "0.5rem", fontSize: "1rem", fontWeight: "500" }}
                    >
                      {item?.candidateName?.at(0) ?? ""}
                    </span>
                    <div className="wd-90p">
                      <div className="d-flex">
                        <h5 className="mb-1">{item.candidateName}</h5>
                        <small className="text-muted ms-auto text-end">
                          {item.messageDateTime}
                        </small>
                      </div>
                      <span> {item.messageText} </span>
                    </div>
                  </span>
                );
              })}
              {props?.data?.length === 0 && !props?.loader && <div style={{ display: "flex", alignItems: "center", justifyContent: "center", top: '130px', position: 'relative' }}>New data not found</div>}
            </div>
          )}
          <div className="dropdown-divider m-0"></div>
          {/* // eslint-disable-next-line jsx-a11y/anchor-is-valid */}
          <a
            href="#"
            onClick={MyNotifications}
            className="dropdown-item text-center p-3 text-muted"
          >
            See all Uploads
          </a>
        </>

        /* <SimpleTable headers={tableHeader} rows={generateRowData()}/>
           <DistanceSummary ref={distanceSummaryRef} />
            {
                mapDataReady() && <DirectionMap apiKey={config.directionAPIKey}
                                                from={ {lat: parseFloat(gpsResult.latitude), lng: parseFloat(gpsResult.longtitude)} }
                                                to={ {lat: parseFloat(props?.locationInfo.latitude), lng: parseFloat(props?.locationInfo.longitude) }}
                                                updateDistanceData={updateDistanceData}/>
            } */
      }
    </div>
  );
};

export default NotificationHeader;